module.exports = __webpack_public_path__ + "img/iconfont.1b74cdeb.svg";